export default __webpack_public_path__ + "static/media/planeAsset 6.dc37c1de.svg";